import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

export const toGetTestimonies = createAsyncThunk<AxiosResponse<any, any>, any>(
  "testimonies/toGetTestimonies",
  async (lang) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}portal/testimonies?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
